<script>
import axios from "axios";

import AdminAppShowDetail from "./AdminAppShowDetail.vue";
import CopiableText from "@/components/CopiableText.vue";

export default {
  components: { AdminAppShowDetail, CopiableText },

  props: {
    // "2026" or "2025" — which contract table the id belongs to.
    year: { type: String, required: true },
    contractId: { type: [String, Number], required: true },
  },

  data: () => ({
    loading: true,
    failed: false,
    data: null,
  }),

  async mounted() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      this.failed = false;
      try {
        const res = await axios.get(
          `/admin/student-referral/by-contract/${this.year}/${this.contractId}`
        );
        this.data = res.data;
      } catch {
        // A failed request tells us nothing about the PINFL, so it must not be
        // reported as "PINFL kiritilmagan" on a student who has one.
        this.data = null;
        this.failed = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div class="student-ref" v-if="!loading">
    <!-- The link is a copiable field like the contract number or the USAT
         login above it, so it uses the same labelled value box. -->
    <template v-if="data && data.hasPinfl">
      <copiable-text :label="$t('Referal havola')" :text="data.link" />
      <admin-app-show-detail
        class="pt-4"
        :title="$t('Taklif qilganlari')"
        :text="data.invitedCount"
      />
    </template>

    <template v-else-if="failed">
      <copiable-text
        :label="$t('Referal havola')"
        :placeholder="$t('Havolani yuklab bo\'lmadi')"
      />
      <v-btn text x-small class="mt-1" @click="load">
        {{ $t("Qayta urinish") }}
      </v-btn>
    </template>

    <copiable-text
      v-else
      :label="$t('Referal havola')"
      :placeholder="$t('PINFL kiritilmagan')"
    />
  </div>
</template>

<style lang="scss" scoped>
.student-ref {
  margin-top: 16px;
}
</style>
